import React from 'react';
import './pageShell.css';

/**
 * PageShell — the new system's page header + body wrapper. Replaces
 * PageLayout for pages migrated to src/ui. A page passes only data
 * (title, actions); it never writes its own header CSS.
 */
export default function PageShell({ title, description, actions, children }) {
  return (
    <div className="ui-page">
      {(title || actions) && (
        <div className="ui-page-header">
          <div>
            {title && <h1 className="ui-page-title">{title}</h1>}
            {description && <p className="ui-page-description">{description}</p>}
          </div>
          {actions && <div className="ui-page-actions">{actions}</div>}
        </div>
      )}
      <div className="ui-page-body">{children}</div>
    </div>
  );
}

/** A small primary/secondary/danger button for page-level actions
 *  (e.g. "add new"), matching the new token system.
 *
 *  `loading` shows a small inline spinner before the label instead of
 *  the caller swapping the label text for "..." — the button stays the
 *  same width and it's obvious something is happening, not just that
 *  the text changed. Callers still pass their own disabled/label text;
 *  this only adds the spinner and implies disabled while loading. */
export function Button({ children, variant = 'primary', loading = false, disabled, ...props }) {
  return (
    <button className={`ui-btn ui-btn-${variant}`} disabled={disabled || loading} {...props}>
      {loading && (
        <span className={`ui-spinner-sm${variant === 'secondary' ? ' ui-spinner-sm-dark' : ''}`} aria-hidden="true" />
      )}
      {children}
    </button>
  );
}

/** The notice/callout box pattern (warnings, info banners). */
export function Notice({ tone = 'info', title, children }) {
  return (
    <div className={`ui-notice ui-notice-${tone}`}>
      {title && <div className="ui-notice-title">{title}</div>}
      <div className="ui-notice-body">{children}</div>
    </div>
  );
}
